export default {
      id: "menu-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#menu-usage",
      toString: function () {
        return this.url;
      }
    }